module.exports = __webpack_public_path__ + "img/spl-2024-sidebar-desktop.779bc29.png";